import { SnackBarService } from './../../services/snack-bar.service';
import { PaysService } from './../../services/pays.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-pays',
  templateUrl: './delete-pays.component.html',
  styleUrls: ['./delete-pays.component.scss']
})
export class DeletePaysComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<DeletePaysComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private paysService: PaysService, private _snackBar: SnackBarService) { }

  ngOnInit(): void {
  }
  onClickYes(){
    this.paysService.deletePays(this.data.id).subscribe(res => {
      this.dialogRef.close();
      this._snackBar.openSnackBar("Supression Reuissie!!", "Fermer");
    });
  }

  onClickNo(){
    this.dialogRef.close();
  }
}
